<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <form @submit.prevent="submitForm">
        <div class="container">
          <div class="area_wrap">
            <div class="aw_blank small">
              <p><b id="userId">{{getSuccess.name}}</b> 회원님,</p>
              <p>새 비밀번호를 설정해 주세요.</p>
            </div>
            <div class="title_wrap">
              <h3>개인정보 입력</h3>
            </div>
            <div class="aw_context tel">
              <div class="article require" :class="{errorLaise : form.password1.hasError}">
                <div class="inputHeader">
                  <p>새 비밀번호</p>
                  <span class="warn" v-text="form.password1.errorTxt" v-if="form.password1.hasError"></span>
                </div>
                <input type="password" placeholder="새 비밀번호" v-model="form.password1.value" maxlength="20" @keyup="blurPassword()" class="pwInput"/>
              </div>
              <div class="article require" :class="{errorLaise : form.password2.hasError}">
                <div class="inputHeader">
                  <p>새 비밀번호 확인</p>
                  <span class="warn" v-text="form.password2.errorTxt" v-if="form.password2.hasError"></span>
                </div>
                <input type="password" placeholder="새 비밀번호 확인" v-model="form.password2.value" maxlength="20" @keyup="blurPasswordConfirm()" class="pwConfirmInput"/>
              </div>
            </div>
          </div>
        </div>
        <div class="btnWrap" :class="{visible : form.password1.flag && form.password2.flag}">
          <button type="submit" :disabled="!checkAll()">확인</button>
        </div>
      </form>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'another',
        closeType: 'close'
      },
      transDate: {
        headerName: '비밀번호 찾기',
        prevUrl: '/passwordFindCertify'
      },
      form: {
        password1: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        password2: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        id: {
          value: ''
        },
        birthDate: {
          value: ''
        },
        userName: {
          value: ''
        },
        tel: {
          value: ''
        }
      },
      setCount: false
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  methods: {
    ...mapActions([
      'PW_FIND_CERTIFY'
    ]),
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapMutations('identity', [
      'SET_IDENTITY_SUCCESS'
    ]),
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    blurPassword () {
      this.form.password1.flag = false
      this.checkPassword()
    },
    checkPassword () {
      if (this.form.password1.flag) return true

      const password = this.form.password1.value
      if (password === '') {
        this.form.password1.hasError = true
        this.form.password1.errorTxt = '비밀번호를 입력해주세요.'
        return false
      }
      const isPw = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,20}$/
      if (!isPw.test(password)) {
        this.form.password1.hasError = true
        this.form.password1.errorTxt = '비밀번호는 영문대/소문자+숫자 조합으로 8~20자를 설정해주세요.'
        return false
      }
      /*  */
      this.form.password1.flag = true
      this.form.password1.hasError = false
      this.form.password1.errorTxt = ''
      return true
    },
    blurPasswordConfirm () {
      this.form.password2.flag = false
      this.checkPasswordConfirm()
    },
    checkPasswordConfirm () {
      const password = this.form.password2.value
      if (password === '') {
        this.form.password2.hasError = true
        this.form.password2.errorTxt = '비밀번호 확인을 입력해주세요.'
        return false
      }
      if (password !== this.form.password1.value) {
        this.form.password2.flag = false
        this.form.password2.hasError = true
        this.form.password2.errorTxt = '비밀번호가 일치하지 않습니다.'
        return false
      }
      this.form.password2.flag = true
      this.form.password2.hasError = false
      this.form.password2.errorTxt = ''
      return true
    },
    checkAll () {
      return !!(this.form.password1.flag && this.form.password2.flag)
    },
    submitForm () {
      if (this.checkAll()) {
        this.formAction()
      } else {
        if (!this.form.password1.flag) {
          this.popupSet.content = '비밀번호를 확인해주세요.'
          this.SET_POPUP(true)
          this.form.password1.hasError = true
          this.form.password1.errorTxt = '비밀번호를 확인해주세요.'
          // document.querySelector('.pwInput').focus()
          return false
        }
        if (!this.form.password1.flag || !this.form.password2.flag) {
          this.popupSet.content = '비밀번호와 비밀번호확인을 체크해주세요.'
          this.SET_POPUP(true)
          this.form.password2.hasError = true
          this.form.password2.errorTxt = '비밀번호와 비밀번호확인을 체크해주세요.'
          // document.querySelector('.pwConfirmInput').focus()
          return false
        }
      }
    },
    async formAction () {
      console.log('this.getIsTemp: ', this.getIsTemp)
      this.form.tel.value = this.formatPhoneNumber(this.form.tel.value)
      this.form.birthDate.value = this.formatBirthNumber(this.form.birthDate.value)
      try {
        const userData = {
          id: this.form.id.value,
          password1: this.form.password1.value,
          password2: this.form.password2.value,
          userName: this.form.userName.value,
          birthDate: this.form.birthDate.value,
          tel: this.form.tel.value
        }
        await this.PW_FIND_CERTIFY(userData)
          .then(() => {
            /* 본인인증 정보 초기화 */
            const userInfo = {
              name: '',
              birthDate: '',
              gender: '',
              mobileno: '',
              dupInfo: ''
            }
            this.SET_IDENTITY_SUCCESS(userInfo)
            // sessionStorage.removeItem('userId')
            this.$router.push('/passwordFindCertifyDone')
            localStorage.removeItem('url')
          })
      } catch (error) {
        console.log('error :', error);
        console.log('비밀번호 찾기 에러에 진입함!')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      } finally {
        this.initForm()
      }
    },
    initForm () {
      this.form.password1.value = ''
      this.form.password2.value = ''
    },
    fetchData () {
      if (this.getSuccess.name === '' || this.getSuccess.birthDate === '' || this.getSuccess.gender === '' || this.getSuccess.mobileno === '' || this.getSuccess.dupInfo === '') {
        this.SET_POPUP(true)
        this.popupSet.count = 'another'
        this.popupSet.content = '잘못된 접근입니다.'
        this.popupSet.closeType = 'action'
        this.popupSet.closeLink = '/'
        this.popupSet.nextLink = '/'
      }
      const name = this.getSuccess.name
      const birthDate = this.getSuccess.birthDate
      const id = sessionStorage.getItem('identityId')
      const tel = this.getSuccess.mobileno

      console.log('id: ', id)
      console.log('name: ', name)
      console.log('tel: ', tel)

      this.form.userName.value = name
      this.form.birthDate.value = birthDate
      this.form.id.value = id
      this.form.tel.value = tel
    },
    formatPhone (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let phone = ''
      if (number.length < 4) {
        return number
      }
      if (number.length < 7) {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3)
      } else if (number.length < 11) {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3, 3)
        phone += '-'
        phone += number.substr(6)
      } else {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3, 4)
        phone += '-'
        phone += number.substr(7)
      }
      return phone
    },
    formatPhoneNumber (obj) {
      this.form.tel.value = this.formatPhone(obj)
      return this.form.tel.value
    },
    formatBirth (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let birth = ''
      if (number.length < 5) {
        return number
      } else if (number.length < 7) {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 5)
        return birth
      } else {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 2)
        birth += '-'
        birth += number.substr(6, 2)
        return birth
      }
    },
    formatBirthNumber (obj) {
      this.form.birthDate.value = this.formatBirth(obj)
      return this.form.birthDate.value
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/isTemp')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  created () {
    console.log('this.getIsTemp.fail: ', this.getIsTemp.fail)
    if (this.getIsTemp.name !== this.getSuccess.name || this.getIsTemp.birthDate.replace(/[^0-9]/g, '') !== this.getSuccess.birthDate) {
      console.log('정보다르다')
      this.SET_POPUP(true)
      this.popupSet.count = 'another'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = '/'
      this.popupSet.nextLink = '/'
      this.popupSet.content = '본인인증 정보와 기존 정보가 일치하지 않습니다. 정보를 확인해주세요.'
      /* 본인인증 정보 초기화 */
      const userInfo = {
        name: '',
        birthDate: '',
        gender: '',
        mobileno: '',
        dupInfo: ''
      }
      this.SET_IDENTITY_SUCCESS(userInfo)
      return false
    }
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.fetchData()
  },
  computed: {
    ...mapGetters([
      'GET_ID',
      'GET_MAIL',
      'getFailIdentity'
    ]),
    ...mapGetters('identity', [
      'getSuccess',
      'getIsTemp'
    ]),
    ...mapGetters('referrer', [
      'getReferrer'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_POPUP(false)
  }
}
</script>

<style lang="scss" scoped>
</style>
